import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Always show the cookie consent popup on page load
    setIsVisible(true);
  }, []);

  const handleAccept = () => {
    // No longer storing consent in localStorage, just close the popup
    setIsVisible(false);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-popup">
        <div className="cookie-consent-content">
          <div className="cookie-logo-section">
            <img src="/Stopkapaint.png" alt="European Union Funding Logo" className="cookie-eu-logo" />
          </div>
          <p>{t('cookie.companyStory')}</p>
          <p className="cookie-eu-info">{t('cookie.euFunding')}</p>
          <div className="language-switcher">
            <button
              className={`lang-btn ${i18n.language === 'pl' ? 'active' : ''}`}
              onClick={() => handleLanguageChange('pl')}
            >
              PL
            </button>
            <button
              className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
              onClick={() => handleLanguageChange('en')}
            >
              EN
            </button>
          </div>
          <button className="accept-btn" onClick={handleAccept}>
            {t('cookie.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;